var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"px-3 pb-2"},[_c('vs-button',{staticClass:"cursor-pointer",attrs:{"icon":"delete","color":"danger","type":"border","svgClasses":"w-5 h-5"},on:{"click":_vm.openConfirm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }